export default {
    god: {
        execute(param, gameState) {
            gameState.god = !gameState.god;
            // gameController.flushStory();
            return [{
                lines: [gameState.god ? "You're now god!" : "You're now mortal!"],
                startAt: 0
            }]
        }
    }
}